import { apiInstance } from "../config/api";

export const contactChannelService = {
  async listProfilerChannels(profilerId: string) {
    const response = await apiInstance.get(
      `/contact-channel/profilers/${profilerId}`,
    );
    return response.data;
  },

  async upsertContactChannel(payload: {
    profilerId: string;
    type: "PHONE_NUMBER" | "WHATSAPP" | "TELEGRAM";
    value: string;
  }) {
    const response = await apiInstance.post("/contact-channel", payload);
    return response.data;
  },
};